import React from 'react';
import { toast } from 'react-toastify';
import { FiCheck, FiX } from 'react-icons/fi';
import { IoAlertCircle } from 'react-icons/io5';
import Loader from 'components/UI/Loader';

type ToastUtilsLoading = (str: {
  pendingStr: string;
  errorStr: string;
  successStr: string;
}) => void;

export type TTdTostType =
  | 'DEFAULT'
  | 'SUCCESS'
  | 'WARNING'
  | 'PENDING'
  | 'LOADING'
  | 'ERROR';

type TTDToast = (type: TTdTostType, str?: string) => string | number | undefined;

const toastIcons: Record<TTdTostType, React.ReactNode> = {
  SUCCESS: <FiCheck className="_isSuccess" />,
  WARNING: <IoAlertCircle className="_isWarning" />,
  PENDING: <Loader />,
  ERROR: <FiX className="_isError" />,
  DEFAULT: null,
  LOADING: null,
};

const toastClassNames: Record<TTdTostType, string> = {
  DEFAULT: 'Toastify__toast--default',
  SUCCESS: 'Toastify__toast--success',
  WARNING: 'Toastify__toast--warning',
  PENDING: 'Toastify__toast--default',
  ERROR: 'Toastify__toast--error',
  LOADING: 'Toastify__toast--default',
};

export const getToastIcon = (type: TTdTostType): React.ReactNode =>
  toastIcons[type];
export const getToastClassName = (type: TTdTostType): string =>
  toastClassNames[type];

const getToastContent = (str?: string) => (
  <div className="Toastify__toast-text">{str || 'Неизвестное оповещение'}</div>
);

export const tdToast: TTDToast = (type = 'DEFAULT', str) => {
  toast(getToastContent(str), {
    icon: getToastIcon(type),
    position: toast.POSITION.TOP_RIGHT,
    className: getToastClassName(type),
  });
};

export const toastLoading: ToastUtilsLoading = ({
  pendingStr,
  errorStr,
  successStr,
}) => {
  const myPromise = new Promise((resolve) =>
    fetch('https://jsonplaceholder.typicode.com/posts/1')
      .then((response) => response.json())
      .then((json) => setTimeout(() => resolve(json), 3000)),
  );

  toast.promise(
    myPromise,
    {
      pending: {
        render: () => getToastContent(pendingStr),
        icon: getToastIcon('PENDING'),
        className: getToastClassName('DEFAULT'),
      },
      error: {
        render: () => getToastContent(errorStr),
        icon: getToastIcon('ERROR'),
        className: getToastClassName('ERROR'),
      },
      success: {
        render: () => getToastContent(successStr),
        icon: getToastIcon('SUCCESS'),
        className: getToastClassName('SUCCESS'),
      },
    },
    {
      position: toast.POSITION.TOP_RIGHT,
    },
  );
};